import { render } from "./UserEditHistoryModal.vue?vue&type=template&id=616a370d"
import script from "./UserEditHistoryModal.vue?vue&type=script&lang=js"
export * from "./UserEditHistoryModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/modals/UserEditHistoryModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "616a370d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('616a370d', __exports__)) {
    api.reload('616a370d', __exports__)
  }
  
  module.hot.accept("./UserEditHistoryModal.vue?vue&type=template&id=616a370d", () => {
    api.rerender('616a370d', render)
  })

}


export default __exports__